var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F5F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4575 10.1789C14.3023 10.152 14.1427 10.1876 14.0139 10.2781C13.885 10.3686 13.7974 10.5064 13.7704 10.6614C13.6162 11.5456 13.1541 12.347 12.4655 12.9239C11.7769 13.5008 10.9063 13.8161 10.0075 13.8141C7.90151 13.8141 6.18813 12.1033 6.18813 10C6.18813 7.89719 7.90151 6.18636 10.0075 6.18636C10.9649 6.18636 11.8654 6.5393 12.5694 7.17697L12.0783 7.66733C12.014 7.73123 11.9688 7.81169 11.9476 7.89973C11.9264 7.98778 11.9301 8.07997 11.9583 8.16604C11.9865 8.25211 12.038 8.32869 12.1072 8.38726C12.1763 8.44583 12.2604 8.48409 12.3501 8.49778L14.4352 8.81908C14.5114 8.83081 14.5893 8.82443 14.6625 8.80046C14.7358 8.7765 14.8023 8.73562 14.8568 8.68116C14.9112 8.62669 14.952 8.56017 14.9759 8.48699C14.9998 8.41382 15.006 8.33605 14.9941 8.26001L14.6729 6.17845C14.6591 6.089 14.6207 6.00512 14.5621 5.93611C14.5034 5.8671 14.4268 5.81566 14.3406 5.7875C14.2545 5.75934 14.1622 5.75556 14.074 5.77658C13.9859 5.7976 13.9053 5.8426 13.8412 5.90658L13.4095 6.33812C12.4868 5.47683 11.2705 4.99841 10.0075 5C7.24655 5 5 7.24321 5 10C5 12.7573 7.24655 15 10.0075 15C12.4471 15 14.5214 13.261 14.9407 10.8651C14.9677 10.7101 14.932 10.5508 14.8414 10.4221C14.7508 10.2934 14.6127 10.206 14.4575 10.1789Z",
    fill: "#6C7C83"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.b9439b00c220ef169ca164a75e73a182.svg";
export { ForwardRef as ReactComponent };